import React, { useState } from 'react';
import { contactAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Mail, MapPin, Send, Loader2 } from 'lucide-react';

export default function ContactPage() {
  const [form, setForm] = useState({ nombre: '', email: '', asunto: '', mensaje: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSending(true);
    try {
      await contactAPI.send(form);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo enviar el mensaje. Intenta de nuevo.');
    }
    setSending(false);
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="contact-page">
      <div className="animate-fade-up">
        <div className="flex items-center gap-3 mb-2">
          <div className="h-0.5 w-8 bg-trans-blue rounded-full" />
          <span className="text-xs font-sans font-semibold tracking-widest uppercase text-trans-blue">Contacto</span>
        </div>
        <h1 className="text-4xl sm:text-5xl font-serif font-bold text-slate-dark">Contactanos</h1>
        <p className="text-base font-sans text-gray-400 mt-3 max-w-lg">
          Tienes preguntas sobre la revista? Escribenos y te responderemos lo antes posible.
        </p>
      </div>

      <div className="grid md:grid-cols-5 gap-12 mt-12">
        <div className="md:col-span-3">
          {sent ? (
            <div className="p-8 bg-green-50 border border-green-100 rounded-sm text-center" data-testid="contact-success">
              <Send className="w-8 h-8 text-green-500 mx-auto mb-3" strokeWidth={1.5} />
              <h3 className="font-serif font-semibold text-slate-dark text-lg">Mensaje enviado</h3>
              <p className="text-sm font-sans text-gray-500 mt-2">Gracias por contactarnos. Te responderemos pronto.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
              {error && <div className="p-3 text-sm font-sans bg-red-50 text-red-600 rounded-md border border-red-100" data-testid="contact-error">{error}</div>}
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1.5">
                  <Label className="font-sans text-sm">Nombre</Label>
                  <Input value={form.nombre} onChange={set('nombre')} required placeholder="Tu nombre" data-testid="contact-name" className="font-sans" />
                </div>
                <div className="space-y-1.5">
                  <Label className="font-sans text-sm">Email</Label>
                  <Input type="email" value={form.email} onChange={set('email')} required placeholder="tu@email.com" data-testid="contact-email" className="font-sans" />
                </div>
              </div>
              <div className="space-y-1.5">
                <Label className="font-sans text-sm">Asunto</Label>
                <Input value={form.asunto} onChange={set('asunto')} required placeholder="Asunto del mensaje" data-testid="contact-subject" className="font-sans" />
              </div>
              <div className="space-y-1.5">
                <Label className="font-sans text-sm">Mensaje</Label>
                <Textarea value={form.mensaje} onChange={set('mensaje')} required placeholder="Escribe tu mensaje aqui..." rows={6} data-testid="contact-message" className="font-sans" />
              </div>
              <Button type="submit" className="bg-slate-dark hover:bg-slate-dark/90 font-sans" disabled={sending} data-testid="contact-submit-btn">
                {sending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />} {sending ? 'Enviando...' : 'Enviar Mensaje'}
              </Button>
            </form>
          )}
        </div>

        <div className="md:col-span-2">
          <div className="p-6 bg-white border border-gray-100 rounded-sm">
            <h3 className="font-serif font-semibold text-slate-dark mb-4">Informacion de Contacto</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-trans-blue mt-1" strokeWidth={1.5} />
                <div>
                  <p className="text-sm font-sans font-medium text-slate-dark">Email</p>
                  <a href="mailto:contacto@archivostrans.com" className="text-sm font-sans text-gray-500 hover:text-trans-blue transition-colors">contacto@archivostrans.com</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-trans-pink mt-1" strokeWidth={1.5} />
                <div>
                  <p className="text-sm font-sans font-medium text-slate-dark">Ubicacion</p>
                  <p className="text-sm font-sans text-gray-500">Ciudad de Mexico, Mexico</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
